module.exports = require("standard-error");


//////////////////
// WEBPACK FOOTER
// external "standard-error"
// module id = 3
// module chunks = 0